import { render, staticRenderFns } from "./aduform.vue?vue&type=template&id=6b2a221e&scoped=true&"
import script from "./aduform.vue?vue&type=script&lang=js&"
export * from "./aduform.vue?vue&type=script&lang=js&"
import style0 from "./aduform.vue?vue&type=style&index=0&id=6b2a221e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2a221e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2a221e')) {
      api.createRecord('6b2a221e', component.options)
    } else {
      api.reload('6b2a221e', component.options)
    }
    module.hot.accept("./aduform.vue?vue&type=template&id=6b2a221e&scoped=true&", function () {
      api.rerender('6b2a221e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/display_auditing/form/aduform.vue"
export default component.exports